import { $POST, $GET } from '@/api/gateway/gatewayMethods';
import {
  GET_ACCOUNT_LIST,
  GET_GROUP_ROLE_LIST,
  UPDATE_GROUP_ROLE_LIST,
  INVITE_ACCOUNT,
  UPDATE_ACCOUNT,
  DELETE_ACCOUNT,
  UPDATE_STATUS_ACCOUNT,
} from '@/api/endpoint-defines/user-management';

export const getGroupRoleListApi = ({ QueryParameters }) =>
  $GET({ EndPoint: GET_GROUP_ROLE_LIST, QueryParameters });

export const updateGroupRoleListApi = ({ BodyData }) =>
  $POST({ EndPoint: UPDATE_GROUP_ROLE_LIST, BodyData });

export const getAccountListApi = () =>
  $GET({ EndPoint: GET_ACCOUNT_LIST, QueryParameters: null });

export const inviteUserApi = ({ BodyData }) =>
  $POST({ EndPoint: INVITE_ACCOUNT, BodyData });

export const updateUserApi = ({ BodyData }) =>
  $POST({ EndPoint: UPDATE_ACCOUNT, BodyData });

export const deleteUserApi = ({ BodyData }) =>
  $POST({ EndPoint: DELETE_ACCOUNT, BodyData });

export const updateStatusUserApi = ({ BodyData }) =>
  $POST({ EndPoint: UPDATE_STATUS_ACCOUNT, BodyData });
